/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SystemRouteImport } from './routes/system'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as ActivateTokenRouteImport } from './routes/activate.$token'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppServersRouteImport } from './routes/_app/servers'
import { Route as AppPlansRouteImport } from './routes/_app/plans'
import { Route as AppPackagesRouteImport } from './routes/_app/packages'
import { Route as AppDomainsRouteImport } from './routes/_app/domains'
import { Route as AppBrandingRouteImport } from './routes/_app/branding'
import { Route as AppAuditRouteImport } from './routes/_app/audit'
import { Route as AppApprovalsRouteImport } from './routes/_app/approvals'
import { Route as AppAccountsRouteImport } from './routes/_app/accounts'
import { Route as PasswordResetTokenRouteImport } from './routes/password.reset.$token'
import { Route as AppUsersTreeRouteImport } from './routes/_app/users_.tree'
import { Route as AppSettingsSystemSsoRouteImport } from './routes/_app/settings_.system.sso'
import { Route as AppSettingsSystemSecurityRouteImport } from './routes/_app/settings_.system.security'
import { Route as AppSettingsSystemGraylogRouteImport } from './routes/_app/settings_.system.graylog'

const SystemRoute = SystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const ActivateTokenRoute = ActivateTokenRouteImport.update({
  id: '/activate/$token',
  path: '/activate/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppServersRoute = AppServersRouteImport.update({
  id: '/servers',
  path: '/servers',
  getParentRoute: () => AppRoute,
} as any)
const AppPlansRoute = AppPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AppRoute,
} as any)
const AppPackagesRoute = AppPackagesRouteImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => AppRoute,
} as any)
const AppDomainsRoute = AppDomainsRouteImport.update({
  id: '/domains',
  path: '/domains',
  getParentRoute: () => AppRoute,
} as any)
const AppBrandingRoute = AppBrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsRoute = AppApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountsRoute = AppAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AppRoute,
} as any)
const PasswordResetTokenRoute = PasswordResetTokenRouteImport.update({
  id: '/password/reset/$token',
  path: '/password/reset/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppUsersTreeRoute = AppUsersTreeRouteImport.update({
  id: '/users_/tree',
  path: '/users/tree',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsSystemSsoRoute = AppSettingsSystemSsoRouteImport.update({
  id: '/settings_/system/sso',
  path: '/settings/system/sso',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsSystemSecurityRoute =
  AppSettingsSystemSecurityRouteImport.update({
    id: '/settings_/system/security',
    path: '/settings/system/security',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsSystemGraylogRoute =
  AppSettingsSystemGraylogRouteImport.update({
    id: '/settings_/system/graylog',
    path: '/settings/system/graylog',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/system': typeof SystemRoute
  '/accounts': typeof AppAccountsRoute
  '/approvals': typeof AppApprovalsRoute
  '/audit': typeof AppAuditRoute
  '/branding': typeof AppBrandingRoute
  '/domains': typeof AppDomainsRoute
  '/packages': typeof AppPackagesRoute
  '/plans': typeof AppPlansRoute
  '/servers': typeof AppServersRoute
  '/settings': typeof AppSettingsRoute
  '/users': typeof AppUsersRoute
  '/activate/$token': typeof ActivateTokenRoute
  '/users/tree': typeof AppUsersTreeRoute
  '/password/reset/$token': typeof PasswordResetTokenRoute
  '/settings/system/graylog': typeof AppSettingsSystemGraylogRoute
  '/settings/system/security': typeof AppSettingsSystemSecurityRoute
  '/settings/system/sso': typeof AppSettingsSystemSsoRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/system': typeof SystemRoute
  '/accounts': typeof AppAccountsRoute
  '/approvals': typeof AppApprovalsRoute
  '/audit': typeof AppAuditRoute
  '/branding': typeof AppBrandingRoute
  '/domains': typeof AppDomainsRoute
  '/packages': typeof AppPackagesRoute
  '/plans': typeof AppPlansRoute
  '/servers': typeof AppServersRoute
  '/settings': typeof AppSettingsRoute
  '/users': typeof AppUsersRoute
  '/activate/$token': typeof ActivateTokenRoute
  '/': typeof AppIndexRoute
  '/users/tree': typeof AppUsersTreeRoute
  '/password/reset/$token': typeof PasswordResetTokenRoute
  '/settings/system/graylog': typeof AppSettingsSystemGraylogRoute
  '/settings/system/security': typeof AppSettingsSystemSecurityRoute
  '/settings/system/sso': typeof AppSettingsSystemSsoRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/system': typeof SystemRoute
  '/_app/accounts': typeof AppAccountsRoute
  '/_app/approvals': typeof AppApprovalsRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/branding': typeof AppBrandingRoute
  '/_app/domains': typeof AppDomainsRoute
  '/_app/packages': typeof AppPackagesRoute
  '/_app/plans': typeof AppPlansRoute
  '/_app/servers': typeof AppServersRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/users': typeof AppUsersRoute
  '/activate/$token': typeof ActivateTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/users_/tree': typeof AppUsersTreeRoute
  '/password/reset/$token': typeof PasswordResetTokenRoute
  '/_app/settings_/system/graylog': typeof AppSettingsSystemGraylogRoute
  '/_app/settings_/system/security': typeof AppSettingsSystemSecurityRoute
  '/_app/settings_/system/sso': typeof AppSettingsSystemSsoRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/system'
    | '/accounts'
    | '/approvals'
    | '/audit'
    | '/branding'
    | '/domains'
    | '/packages'
    | '/plans'
    | '/servers'
    | '/settings'
    | '/users'
    | '/activate/$token'
    | '/users/tree'
    | '/password/reset/$token'
    | '/settings/system/graylog'
    | '/settings/system/security'
    | '/settings/system/sso'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/system'
    | '/accounts'
    | '/approvals'
    | '/audit'
    | '/branding'
    | '/domains'
    | '/packages'
    | '/plans'
    | '/servers'
    | '/settings'
    | '/users'
    | '/activate/$token'
    | '/'
    | '/users/tree'
    | '/password/reset/$token'
    | '/settings/system/graylog'
    | '/settings/system/security'
    | '/settings/system/sso'
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/system'
    | '/_app/accounts'
    | '/_app/approvals'
    | '/_app/audit'
    | '/_app/branding'
    | '/_app/domains'
    | '/_app/packages'
    | '/_app/plans'
    | '/_app/servers'
    | '/_app/settings'
    | '/_app/users'
    | '/activate/$token'
    | '/_app/'
    | '/_app/users_/tree'
    | '/password/reset/$token'
    | '/_app/settings_/system/graylog'
    | '/_app/settings_/system/security'
    | '/_app/settings_/system/sso'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  SystemRoute: typeof SystemRoute
  ActivateTokenRoute: typeof ActivateTokenRoute
  PasswordResetTokenRoute: typeof PasswordResetTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/system': {
      id: '/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof SystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/activate/$token': {
      id: '/activate/$token'
      path: '/activate/$token'
      fullPath: '/activate/$token'
      preLoaderRoute: typeof ActivateTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/servers': {
      id: '/_app/servers'
      path: '/servers'
      fullPath: '/servers'
      preLoaderRoute: typeof AppServersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plans': {
      id: '/_app/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof AppPlansRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/packages': {
      id: '/_app/packages'
      path: '/packages'
      fullPath: '/packages'
      preLoaderRoute: typeof AppPackagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/domains': {
      id: '/_app/domains'
      path: '/domains'
      fullPath: '/domains'
      preLoaderRoute: typeof AppDomainsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/branding': {
      id: '/_app/branding'
      path: '/branding'
      fullPath: '/branding'
      preLoaderRoute: typeof AppBrandingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals': {
      id: '/_app/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AppApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounts': {
      id: '/_app/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AppAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/password/reset/$token': {
      id: '/password/reset/$token'
      path: '/password/reset/$token'
      fullPath: '/password/reset/$token'
      preLoaderRoute: typeof PasswordResetTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/users_/tree': {
      id: '/_app/users_/tree'
      path: '/users/tree'
      fullPath: '/users/tree'
      preLoaderRoute: typeof AppUsersTreeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/system/sso': {
      id: '/_app/settings_/system/sso'
      path: '/settings/system/sso'
      fullPath: '/settings/system/sso'
      preLoaderRoute: typeof AppSettingsSystemSsoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/system/security': {
      id: '/_app/settings_/system/security'
      path: '/settings/system/security'
      fullPath: '/settings/system/security'
      preLoaderRoute: typeof AppSettingsSystemSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/system/graylog': {
      id: '/_app/settings_/system/graylog'
      path: '/settings/system/graylog'
      fullPath: '/settings/system/graylog'
      preLoaderRoute: typeof AppSettingsSystemGraylogRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountsRoute: typeof AppAccountsRoute
  AppApprovalsRoute: typeof AppApprovalsRoute
  AppAuditRoute: typeof AppAuditRoute
  AppBrandingRoute: typeof AppBrandingRoute
  AppDomainsRoute: typeof AppDomainsRoute
  AppPackagesRoute: typeof AppPackagesRoute
  AppPlansRoute: typeof AppPlansRoute
  AppServersRoute: typeof AppServersRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppUsersRoute: typeof AppUsersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppUsersTreeRoute: typeof AppUsersTreeRoute
  AppSettingsSystemGraylogRoute: typeof AppSettingsSystemGraylogRoute
  AppSettingsSystemSecurityRoute: typeof AppSettingsSystemSecurityRoute
  AppSettingsSystemSsoRoute: typeof AppSettingsSystemSsoRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountsRoute: AppAccountsRoute,
  AppApprovalsRoute: AppApprovalsRoute,
  AppAuditRoute: AppAuditRoute,
  AppBrandingRoute: AppBrandingRoute,
  AppDomainsRoute: AppDomainsRoute,
  AppPackagesRoute: AppPackagesRoute,
  AppPlansRoute: AppPlansRoute,
  AppServersRoute: AppServersRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppUsersRoute: AppUsersRoute,
  AppIndexRoute: AppIndexRoute,
  AppUsersTreeRoute: AppUsersTreeRoute,
  AppSettingsSystemGraylogRoute: AppSettingsSystemGraylogRoute,
  AppSettingsSystemSecurityRoute: AppSettingsSystemSecurityRoute,
  AppSettingsSystemSsoRoute: AppSettingsSystemSsoRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  SystemRoute: SystemRoute,
  ActivateTokenRoute: ActivateTokenRoute,
  PasswordResetTokenRoute: PasswordResetTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
